export const iconFontAwesomeCharityHandshake = (
	<i className="fa-solid fa-handshake"></i>
);
